// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NH6zm","tooltip":"styles_tooltip__WHCqc","tooltipText":"styles_tooltipText__j-pyN","info":"styles_info__izpVF"};